import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { Button } from '../../../web/components-v2/Button';
import { TextArea } from '../../../web/components-v2/TextArea';
import { useErrorMessages } from '../../hooks';
import { ApiClient } from '../../services/api';
import { BasicPage } from '../BasicPage';
import { styleSheet } from './styles';

export const VoicemailContainer: React.FC = () => {
	const userSession = useUserSession();
	const errorMessages = useErrorMessages();

	const [message, setMessage] = useState<string>('');

	const client = new ApiClient(userSession);

	const getCurrentVoicemail = async () => {
		try {
			const result = await client.getVoicemailText();
			if (!result.success) {
				throw Api.asApiError(result);
			}

			setMessage(result.value);
			return result;
		} catch (error) {
			errorMessages.pushApiError(error);
		}
	};

	const updateCurrentVoicemail = async (newMessage: string) => {
		try {
			const result = await client.updateVoicemailText(newMessage);
			if (!result.success) {
				throw Api.asApiError(result);
			}

			toast.success('Voicemail message updated.');
			return result;
		} catch (error) {
			errorMessages.pushApiError(error);
		}
	};

	useEffect(() => {
		getCurrentVoicemail();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleInputChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
		const { target } = event;
		setMessage(target.value);
	};

	// const handlePreview = () => {};

	const handleSave = () => updateCurrentVoicemail(message);

	return (
		<BasicPage title='Voicemail' appearance='light'>
			<div className={css(styleSheet.container)}>
				<div className={css(styleSheet.box)}>
					<div className={css(styleSheet.intro)}>
						<h2 className={css(styleSheet.header)}>Customize Greeting</h2>
						<p className={css(styleSheet.description)}>
							Type in your greeting below, and our robot will read it out loud when people leave a voicemail.
						</p>
					</div>
					<TextArea
						id='voicemail-greeting'
						aria-label='Voicemail greeting'
						rows={8}
						onChange={handleInputChange}
						placeholder='Write your message here...'
						value={message}
					/>
					<div className={css(styleSheet.actions)}>
						<Button onClick={handleSave}>Save</Button>
					</div>
				</div>
			</div>
		</BasicPage>
	);
};
